export const TOTAL_TEXT_GROUPS = 6;